export default __webpack_public_path__ + "static/media/img-ways-partners-mobile.d96aedbc.png";